/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Total monetary amount of special equipment.   (german: Geldwert der Sonderausstattung)
 */
export interface SpecialEquipmentAmount {
  /**
   * Monetary value in format format *eee.cc* , separated by dot.   Default currency is Euro and Cent.   (german: Geldbetrag)   (bipro-datentypen::Betrag)
   */
  monetaryAmount?: string;
}
